import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import useTranslation from "../../hooks/useTranslation";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import OutlinedButton from "../NSButton/Types/OutlinedButton";

const DialogHabilidades = ({
  icon,
  text,
  callbackConfirm,
  callbackCancel,
  status,
  action01,
  action02,
  action03,
  action04,
}) => {
  const T = useTranslation();
  const [isOpen, setIsOpen] = useState(status);
  const handlerClose = () => {
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerOnConfirm = () => {
    if (callbackConfirm) {
      callbackConfirm();
    }
  };

  useEffect(() => {
    setIsOpen(status);
  }, [status]);

  return (
    <>
      <FloatingDialog isOpen={isOpen} onClose={handlerClose}>
        <div className="flex p-10 gap-3 flex-col w-full h-full items-center justify-center">
          {icon && (
            <div className="rounded flex items-center justify-center text-xl bg-[#2aac9c] w-[32px] h-[32px] text-white border">
              <img src={icon} className="w-full h-full" />
            </div>
          )}
          <span className="font-bold text-center text-base">{T(text)}</span>
          <div className="flex flex-col gap-4">
            <OutlinedButton title= {"Medir habilidades no técnicas"} onClick={action01} />
            <OutlinedButton title= {"Medir calidad RCP"} onClick={action02} />
            <OutlinedButton title= {"Medir ambas"} onClick={action03} />
            <OutlinedButton title= {"No medir ninguna"} onClick={action04} />
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogHabilidades;
